// pipe (floor stations, Task 0): the Finance sidebar entry — the way into invoicing and settlement.
//
// Cloned from sites-button.tsx (verbatim shape) PLUS the station gate: it renders ONLY when the
// SERVER says this actor may work the invoices station — `/me/provisioning`'s `stations.invoices`
// (`rbac::may_work_station`, composed from `authorize_erp_write` + `guard_lifecycle`'s stage pair
// on `invoice`), read through the shared `stationGranted` SSOT. NEVER a client-side role check
// (the enshrined 4B.6 rule), and fail-closed: while provisioning is unresolved, errored, or served
// by a not-yet-redeployed server, the entry stays hidden so it can never flash for an actor the
// server would deny. The Core API re-checks every Finance request regardless of this affordance.
//
// It exists as its own sidebar entry (rather than an Operations sub-nav row) because invoicing is
// not floor work: it is the Finance station, and the four Operations stations already live under
// the one "Operations" entry.
import { useI18n } from '@affine/i18n';
import { ExportIcon } from '@blocksuite/icons/rc';
import { useServices } from '@toeverything/infra';

import { stationGranted } from '../../desktop/pages/workspace/stations/station-registry';
import { MenuLinkItem } from '../../modules/app-sidebar/views';
import { useErpProvisioning } from '../../modules/erp';
import { WorkbenchService } from '../../modules/workbench';
import { useNavPrefixActive } from './use-nav-prefix-active';

export const FinanceButton = () => {
  const t = useI18n();
  const provisioning = useErpProvisioning();
  const { workbenchService } = useServices({ WorkbenchService });
  const workbench = workbenchService.workbench;
  // REACTIVE active state: any `/finance/*` route keeps the entry lit.
  const active = useNavPrefixActive(workbench, '/finance');

  if (!stationGranted(provisioning, 'invoices')) {
    return null;
  }

  return (
    <MenuLinkItem
      icon={<ExportIcon />}
      active={active}
      to={'/finance/invoices'}
    >
      <span data-testid="pipe-finance-nav">
        {t['com.affine.pipe.finance.nav']()}
      </span>
    </MenuLinkItem>
  );
};
